import { render } from "./VueCollapsiblePanel.vue?vue&type=template&id=64321428&scoped=true"
import script from "./VueCollapsiblePanel.vue?vue&type=script&lang=ts"
export * from "./VueCollapsiblePanel.vue?vue&type=script&lang=ts"

import "./VueCollapsiblePanel.vue?vue&type=style&index=0&id=64321428&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64321428"

export default script